<div mat-dialog-title class="d-flex align-items-center">
  <div class="d-flex align-items-center w-100">
    <img alt="g-modal-image" *ngIf="true" src="./assets/icons/success.svg" class="dhl-dialog-img" />
    <h2 color="red" class="dhl-dialog-title">{{ dialogData.title ? dialogData.title : 'Confirmar' }}</h2>
  </div>
  <div class="flex-shrink-1">
    <div class="position-absolute top-0 end-0 p-2">
      <button mat-icon-button [mat-dialog-close]="false" color="accent">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div class="row">
    <div class="col" [innerHTML]="dialogData.message"></div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <p>Para completar la actualizacion de información debe dar en el botón guardar registros.</p>
    </div>
  </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-end">
  <button
    *ngIf="dialogData.showCancel"
    mat-stroked-button
    color="accent"
    (click)="onCancel()"
    class="dhl-btn-secundary"
    [innerHTML]="dialogData.cancelLabel ? dialogData.cancelLabel : 'Cancelar'"></button>
  <button *ngIf="dialogData.showAccept" mat-flat-button cdkFocusInitial color="accent" (click)="onAccept()" class="dhl-btn-primary">
    {{ dialogData.acceptLabel ? dialogData.acceptLabel : 'Aceptar' }}
  </button>
</div>
